 /** @jsxImportSource @emotion/react */
 import { css} from '@emotion/react';
import React,{useContext} from 'react'
import { Popover } from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {ButtonBase} from '@mui/material';
import moment from 'moment/moment';

import { useEffect } from 'react';


export default function Card({ matchData, handleBetMatchClick, selectedBetCard, summary, betTime,goals }) {

   

    const [anchorEl, setAnchorEl] = React.useState(null);
    const firstArrPeriod = matchData.odd[0].periods;
    const [matchTimeRange, setMatchTimeRange] = React.useState(`${summary ? betTime : firstArrPeriod}`);
    const open = Boolean(anchorEl);
    const handleBetTimeRangeClick = (e) => {
        if (matchData?.odd?.length == 1) return // it means there is only one periods
        (Boolean(anchorEl)) ? setAnchorEl(null) : setAnchorEl(e.currentTarget)
    }
    const handleBetTimeRangeOptionClick = (matchId, period) => {
        setMatchTimeRange(period)
        handleBetMatchClick({ matchId }) // to remove selection in that match
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    useEffect(()=>{
        if(matchData?.odd?.length == 1){
           let periods = matchData.odd[0].periods;
            setMatchTimeRange(periods)
        }
    },[])
    const bettingSelectedColor = "gray"

    function getSlipStatusBg(){
        let backgroundColor;
        if(status == 'pending') backgroundColor= "#A47E3B"
        if(status == 'win') backgroundColor= "#408E91"
        if(status == 'loss') backgroundColor= "#9C254D"
        if(status == 'refund') backgroundColor= "rgb(100 39 118)"
        if(status == 'draw') backgroundColor= "#9C254D"
        if(status == "partially win") backgroundColor = '#408E91' ;
        if(status == "partially lose") backgroundColor = '#9C254D' ;
        return backgroundColor;
    }

    function getSlipStatusText(){
        let word;
        if(status == "pending") word = 'playing' ;
        if(status == "win") word = 'win' ;
        if(status == "loss") word = 'lose' ;
        if(status == "refund") word = 'refund' ;
        if(status == "draw") word = 'lose' ;
        if(status == "partially win") word = 'partially win' ;
        if(status == "partially lose") word = 'partially lose' ;
        return word;
     }

    const hdpConverted = matchData?.odd?.filter(o => o.periods == matchTimeRange)[0]?.hdp?.converted;
    const ouConverted = matchData?.odd?.filter(o => o.periods == matchTimeRange)[0]?.ou?.converted;

    const converted = selectedBetCard.converted;
    const middleSign = converted.charAt(converted.split(/[+-]/)[0].length);
    let status = matchData?.status;

    const home_team_has_hadicap = matchData?.odd?.filter(o => o.periods == matchTimeRange)[0]?.hdp?.home_team_has_hadicap;

    // if(status == "draw"){
    //     if(middleSign == "+") {
    //         if(selectedBetCard.oddType == "ou"){
    //             if(selectedBetCard.selectedTeam == "over") {
    //                 status = "partially win"
    //             }else{
    //                 status = "partially lose"
    //             }
    //         }else{
    //             if(home_team_has_hadicap) {
    //                 if(selectedBetCard.selectedTeam == "home"){
    //                     status = "partially win"
    //                 }else{
    //                     status = "partially lose"
    //                 }
    //             }else{
    //                 if(selectedBetCard.selectedTeam == "away"){
    //                     status = "partially win"
    //                 }else{
    //                     status = "partially lose"
    //                 }
    //             }
    //         }
    //     }
    //     if(middleSign == "-") {
    //         if(selectedBetCard.oddType == "ou"){
    //             if(selectedBetCard.selectedTeam == "under") {
    //                 status = "partially win"
    //             }else{
    //                 status = "partially lose"
    //             }
    //         }else{
    //             if(home_team_has_hadicap) {
    //                 if(selectedBetCard.selectedTeam == "home"){
    //                     status = "partially lose"
    //                 }else{
    //                     status = "partially win"
    //                 }
    //             }else{
    //                 if(selectedBetCard.selectedTeam == "away"){
    //                     status = "partially lose"
    //                 }else{
    //                     status = "partially win"
    //                 }
    //             }
    //         }
            
    //     }
    // }
    if(status == "pwin") {
        status = "partially win"
    }
    if(status == "ploss"){
        status = "partially lose"
    }

    let backgroundColor = getSlipStatusBg();

    return (
        <div>

            <div style={{ display: "flex", marginTop: "1.8rem", marginBottom: "1rem", justifyContent: "space-between" }}>
              
                <div style={{display: "flex"}}>
                    <ButtonBase disabled={summary ? true : false} onClick={handleBetTimeRangeClick} style={{ height: "35px", display: 'inline-flex', alignItems: "center", padding: `${(matchData?.odd?.length > 1 && !summary) ? '0 0 0 10px' : "0 22px"}`, backgroundColor: "white", borderRadius: "9px", cursor: "pointer" }}>
                        <h4 style={{ margin: 0 }} >
                            {matchTimeRange == "full_time" && "FT"}
                            {matchTimeRange == "first_time" && "1H"}
                            {matchTimeRange == "second_time" && "2H"}
                        </h4>
                        <Popover
                            // id={id}
                            open={open}
                            anchorEl={anchorEl}
                            onClose={handleClose}
                            PaperProps={{ style: { borderRadius: "0.9rem",display: 'flex',flexDirection: 'column' } }}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                        >
                            {
                                matchData?.odd?.map((o) => {
                                    return (
                                        (o.periods != matchTimeRange) && <ButtonBase key={o.id}>
                                            <div onClick={() => handleBetTimeRangeOptionClick(matchData?.matchId, o.periods)} style={{ textAlign: "center", padding: "80px 0", backgroundColor: "white", borderRadius: "", cursor: "pointer", width: "100px" }}>
                                                <h4 style={{ margin: 0 }} className="" >
                                                    {o.periods == "full_time" && "FT"}
                                                    {o.periods == "first_time" && "1H"}
                                                    {o.periods == "second_time" && "2H"}
                                                </h4>
                                            </div>
                                        </ButtonBase>
                                    )
                                })
                            }
                        </Popover>
                    
                        {(matchData?.odd?.length > 1 && !summary) && (open ? <ExpandLess style={{ width: "3.6rem", height: "2rem", borderRadius: "3rem", marginTop: 0 }} /> : <ExpandMore style={{ width: "3.6rem", height: "2rem", borderRadius: "3rem", marginTop: 0 }} />)}
                    </ButtonBase>
                    {status &&  <div style={{display: 'flex',justifyContent: 'center',alignItems: 'center',marginLeft: "10px"}}><div style={{padding: "6px 8px",backgroundColor: backgroundColor,borderRadius: "10px",fontWeight: "bold",color: 'white'}}>
                               {getSlipStatusText()}
                                </div></div>
                    }
                </div>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
                    <h5 style={{ margin: 0, marginBottom: "3px"}}>Match time</h5>
                    <h5 style={{ margin: 0 }}>{moment(matchData?.matchDate).format('MM-DD-YYYY h:mmA')}</h5>
                </div>
            </div>
            <div
            css={css`
                margin: 10px 0;
                border-radius: 1rem;
                box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
                -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
                -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
                `}
            style={{ backgroundColor: "white", borderRadius: "1.3rem" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ButtonBase style={{ height: "80px", borderRadius: "1.3rem 0 0 0", backgroundColor: `${(selectedBetCard?.matchId == matchData?.matchId && selectedBetCard.selectedTeam == "home") ? bettingSelectedColor : ""}`, padding: "20px 0", display: "flex", flexDirection: "column", alignItems: "center", flexBasis: "50%", borderWidth: "0 0.5px 0 0", borderStyle: "solid", borderColor: "#4F4F4F" }} onClick={() => handleBetMatchClick({ periods: matchTimeRange, matchId: matchData?.matchId, oddType: "hdp", selectedTeam: "home", converted: hdpConverted })}>
                        <h4 style={{ margin: 0 }}>{matchData?.homeTeam?.name_en}</h4>
                        { (!home_team_has_hadicap && !goals ) ||
                            <div style={{ marginTop: "12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                { home_team_has_hadicap &&
                                <div style={{ width: "46px", height: "26px", backgroundColor: "#87CEEB", display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: "10px", cursor: "pointer" }}>
                                    <h4 style={{ margin: 0 }} className="black">
                                        {hdpConverted}
                                    </h4>
                                </div>
                                }
                                {goals && 
                                <h3 style={{margin: 0,marginLeft: "20px"}}>{goals.home || 0}</h3>
                                }
                            </div>
                        }
                    </ButtonBase>
                    <ButtonBase style={{ height: "80px", borderRadius: "0 1.3rem 0 0", backgroundColor: `${(selectedBetCard?.selectedTeam == "away" && selectedBetCard?.matchId == matchData?.matchId) ? bettingSelectedColor : ""}`, flexBasis: "50%", padding: "20px 0", display: "flex", flexDirection: "column", alignItems: "center" }} onClick={() => handleBetMatchClick({ periods: matchTimeRange, matchId: matchData?.matchId, oddType: "hdp", selectedTeam: "away", converted: hdpConverted })}>
                        <h4 style={{ margin: 0 }}>{matchData?.awayTeam?.name_mm}</h4>
                        {(home_team_has_hadicap && !goals) ||
                            <div style={{ marginTop: "12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                {goals && 
                                <h3 style={{margin: 0,marginRight: "20px"}}>{goals.away || 0}</h3>
                                }
                                { !home_team_has_hadicap &&
                                <div style={{ width: "46px", height: "26px", backgroundColor: "#87CEEB", display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: "10px", cursor: "pointer" }}>
                                    <h4 style={{ margin: 0 }} className="black">
                                        {hdpConverted}
                                    </h4>
                                </div>
                                }
                               
                            </div>
                        }
                        
                    </ButtonBase>
                </div>
                <div style={{ display: "flex", position: 'relative' }}>
                    <ButtonBase style={{ borderRadius: "0  0 0 1.3rem", backgroundColor: `${(selectedBetCard?.selectedTeam == 'over' && selectedBetCard?.matchId == matchData?.matchId) ? bettingSelectedColor : ""}`, flexBasis: "50%", borderWidth: "0.5px 0.5px 0 0", borderStyle: "solid", borderColor: "#4F4F4F" }} onClick={() => handleBetMatchClick({ periods: matchTimeRange, matchId: matchData?.matchId, oddType: "ou", selectedTeam: "over", converted: ouConverted })}>
                        <h4 style={{ margin: "15px 0", }}>Over</h4>
                    </ButtonBase>
                    <ButtonBase style={{ borderRadius: "0  0 1.3rem 0", backgroundColor: `${(selectedBetCard?.selectedTeam == 'under' && selectedBetCard?.matchId == matchData?.matchId) ? bettingSelectedColor : ""}`, flexBasis: "50%", borderWidth: "0.5px 0 0 0", borderStyle: "solid", borderColor: "#4F4F4F" }} onClick={() => handleBetMatchClick({ periods: matchTimeRange, matchId: matchData?.matchId, oddType: "ou", selectedTeam: "under", converted: ouConverted })}>
                        <h4 style={{ margin: "15px 0" }}>Under</h4>
                    </ButtonBase>
                    <div style={{ position: "absolute", left: `calc(50% - 23px)`, top: `calc(50% - 13px)`, width: "46px", height: "26px", backgroundColor: "#87CEEB", display: 'flex', justifyContent: 'center', alignItems: "center", borderRadius: "10px", cursor: "pointer" }}>
                        <h4 style={{ margin: 0 }} className="black">
                            {ouConverted}
                        </h4>
                    </div>
                </div>
            </div>
        </div>
    )
}
